import React, { useState, useContext } from 'react';
import styled from 'styled-components';
import Picker from 'react-date-picker';
import LanguageContext from '@lib/contexts/languageContext';
import 'react-date-picker/dist/DatePicker.css';
import 'react-calendar/dist/Calendar.css';

const localeMap = {
  en: 'en',
  se: 'sv',
  no: 'nb',
  fi: 'fi',
};

const Wrapper = styled.div`
  .react-date-picker {
    width: 100%;

    .react-date-picker__wrapper {
      display: none;
    }

    .react-calendar__navigation__label {
      font-weight: 500;
      font-size: 1em;
      text-transform: capitalize;
    }

    .react-calendar__navigation__arrow[disabled],
    .react-calendar__tile:disabled {
      background: none;
      pointer-events: none;
    }

    .react-calendar__tile {
      position: relative;
      font-size: 1em;
      text-transform: capitalize;
      background: none;

      abbr {
        position: relative;
        z-index: 2;
      }

      &:before {
        content: '';
        position: absolute;
        top: 0;
        left: calc(50% - 17px);
        width: 35px;
        height: 35px;
        border-radius: 50%;
        opacity: 0;
        transition: opacity 300ms ease-in-out;
      }

      :hover:before {
        opacity: 1;
        background-color: #e6e6e6;
      }

      &.react-calendar__tile--active {
        :before {
          opacity: 1;
          background-color: #56b9e5;
        }
      }
    }

    .react-calendar__tile--now:not(.react-calendar__tile--active) {
      font-weight: 600;
      text-decoration: underline;
      background: none;
    }
    .react-calendar button:enabled {
      border-radius: 10px;
    }

    .react-date-picker__calendar {
      width: 100%;
      position: static !important;
      height: auto !important;

      .react-calendar {
        border: none;
        width: 100%;
      }
    }
  }
`;

const DatePicker = () => {
  const lang = useContext(LanguageContext);
  const [value, setValue] = useState(null);

  return (
    <Wrapper>
      <Picker
        onBlur={e => e.stopPropagation()}
        onChange={setValue}
        value={value}
        dayPlaceholder="dd"
        monthPlaceholder="mm"
        yearPlaceholder="yyyy"
        format="dd/MM/yyyy"
        minDate={new Date()}
        calendarIcon={null}
        locale={localeMap[lang]}
        isOpen={true}
        shouldCloseCalendar={() => false}
      />
    </Wrapper>
  );
};

export default DatePicker;
